<template>
  <b-container fluid class="default-container responsive-padding">
    <!-- Sólo lo ve quien compra Eureka sin tener colegio, o sea quien nunca
         apretó "Probarla". Con el nivel podemos dejarle el curso armado y los
         tres estudiantes de ejemplo, que es lo que le explica cómo se usa. -->
    <b-modal
      ref="level-modal"
      title="¿Con qué nivel trabajas?"
      ok-title="Continuar"
      cancel-title="Cancelar"
      :ok-disabled="selectedLevel === null"
      @ok="confirmLevel"
      @hidden="onLevelModalHidden"
    >
      <p class="text-muted">
        Vamos a dejarte un curso listo con estudiantes de ejemplo para que veas
        cómo se aplica y se corrige una prueba. Después puedes agregar los
        tuyos.
      </p>
      <b-form-select
        v-model="selectedLevel"
        :options="levelOptions"
        aria-label="Nivel del curso"
      />
    </b-modal>
    <b-row>
      <!-- Form Section -->
      <b-col lg="8" md="12" class="text-left border-right-lg">
        <b-container>
          <b-row class="mb-4">
            <b-col>
              <div class="hero-section">
                <h2 class="hero-title">
                  <span class="title-icon">🛒</span>
                Compra tus usos de {{ servicesNames[service] }}!
              </h2>
                <div class="title-underline"></div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col>
              <div class="usage-card">
                <div class="usage-icon">📊</div>
                <p class="usage-text">
                  Actualmente cuentas con
                  <strong class="usage-count">{{ currentUses }}</strong> usos.
              </p>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col class="text-left">
              <div class="section-header">
                <h4 class="section-title">
                  <span class="section-icon">📝</span>
                  Completa tus datos de facturación
                </h4>
              </div>
            </b-col>
          </b-row>
          <div class="form-container">
          <b-row class="mb-3">
            <b-col>
              <div class="document-type-section">
                <label class="form-label mb-2">Tipo de documento tributario</label>
                <b-form-radio-group
                  v-model="documentType"
                  :options="documentTypeOptions"
                  name="document-type"
                  class="document-type-radios"
                  stacked
                />
                <div v-if="isExport" class="export-notice mt-2">
                  <span class="export-icon">🌍</span>
                  <span>Se generará Factura de Exportación Electrónica (país distinto a Chile)</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
              <b-col md="6" sm="12">
              <b-form-group
                label="Nombre*"
                label-size="sm"
                  label-class="form-label"
                >
                  <b-form-input 
                    v-model="name" 
                    required 
                    size="sm" 
                    type="text"
                    class="form-input"
                    placeholder="Tu nombre completo"
                  />
              </b-form-group>
            </b-col>
              <b-col md="6" sm="12">
              <b-form-group
                label="Apellido*"
                label-size="sm"
                  label-class="form-label"
              >
                <b-form-input
                  v-model="lastName"
                  required
                  size="sm"
                  type="text"
                    class="form-input"
                    placeholder="Tu apellido"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
              <b-col md="6" sm="12">
              <b-form-group
                label="Correo*"
                label-size="sm"
                  label-class="form-label"
                >
                  <b-form-input 
                    v-model="email" 
                    required 
                    size="sm" 
                    type="email"
                    class="form-input"
                    placeholder="tu@email.com"
                  />
              </b-form-group>
            </b-col>
              <b-col md="6" sm="12">
              <b-form-group
                label="Teléfono*"
                label-size="sm"
                  label-class="form-label"
                >
                  <b-form-input 
                    v-model="phone" 
                    required 
                    size="sm" 
                    type="tel"
                    class="form-input"
                    placeholder="+56 9 1234 5678"
                  />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
              <b-col md="6" sm="12">
              <b-form-group
                label="País*"
                label-size="sm"
                  label-class="form-label"
                  :description="documentType === 'boleta' ? 'La boleta solo aplica a Chile. Elige Factura para vender al extranjero.' : ''"
              >
                <b-form-select
                  v-model="country"
                  required
                  size="sm"
                  :disabled="documentType === 'boleta'"
                >
                  <b-form-select-option v-for="option in countryOptions"
                  :key="option.value" :value="option.value">{{ option.text }}</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
              <b-col md="6" sm="12">
              <b-form-group
                label="Ciudad*"
                label-size="sm"
                  label-class="form-label"
                >
                  <b-form-input 
                    v-model="city" 
                    required 
                    size="sm" 
                    type="text"
                    class="form-input"
                    placeholder="Santiago"
                  />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Dirección*"
                label-size="sm"
                  label-class="form-label"
              >
                <b-form-input
                  v-model="address"
                  required
                  size="sm"
                  type="text"
                    class="form-input"
                    placeholder="Calle 123, Comuna"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
              <b-col md="6" sm="12" v-if="!isExport">
              <b-form-group
                label="RUT*"
                label-size="sm"
                  label-class="form-label"
                >
                  <b-form-input
                    v-model="rut"
                    required
                    size="sm"
                    type="text"
                    class="form-input"
                    placeholder="12345678-9"
                    :state="rutTouched && rut ? rutIsValid : null"
                    @blur="rutTouched = true"
                  />
                  <b-form-invalid-feedback :state="rutTouched && rut ? rutIsValid : null">
                    RUT inválido
                  </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
              <b-col md="6" sm="12" v-if="documentType === 'factura' || isExport">
              <b-form-group
                :label="isExport ? 'Razón Social / Nombre' : 'Razón Social*'"
                label-size="sm"
                  label-class="form-label"
                >
                  <b-form-input
                    v-model="razonSocial"
                    required
                    size="sm"
                    type="text"
                    class="form-input"
                    placeholder="Nombre o Razón Social"
                  />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="documentType === 'factura' || isExport">
              <b-col md="6" sm="12">
              <b-form-group
                :label="isExport ? 'Giro / Actividad' : 'Giro*'"
                label-size="sm"
                  label-class="form-label"
                >
                  <b-form-input
                    v-model="giro"
                    required
                    size="sm"
                    type="text"
                    class="form-input"
                    placeholder="Actividad económica"
                  />
              </b-form-group>
            </b-col>
              <b-col md="6" sm="12">
              <b-form-group
                :label="isExport ? 'Comuna / Ciudad' : 'Comuna*'"
                label-size="sm"
                  label-class="form-label"
                >
                  <b-form-input
                    v-model="comuna"
                    required
                    size="sm"
                    type="text"
                    class="form-input"
                    placeholder="Ñuñoa"
                  />
              </b-form-group>
            </b-col>
          </b-row>
          </div>
        </b-container>
      </b-col>
      
      <!-- Purchase Section -->
      <b-col lg="4" md="12" class="my-auto mt-4 mt-lg-0">
        <div class="purchase-section">
          <div class="quantity-section">
            <div class="quantity-header">
              <span class="quantity-icon">🔢</span>
              <h5 class="quantity-title">Cantidad de usos</h5>
            </div>
            <div class="quantity-input-container">
            <b-form-input
              type="number"
              v-model="amount"
              min="1"
              placeholder="Cantidad de usos"
                class="quantity-input"
              />
            </div>
          </div>
          
          <div class="purchase-card-container">
                  <b-card
              class="purchase-card"
                    @click="handleCardClick(codes[service])"
                  >
              <div class="purchase-header">
                <div class="purchase-icon">💳</div>
                <h4 class="purchase-title">¡Comprar Ahora!</h4>
              </div>
              
              <div class="payment-method">
                      <b-img
                        :src="
                          $store.state.login.hasEnrolled
                            ? oneClickIcon
                            : webpayIcon
                        "
                  class="payment-icon"
                  fluid
                />
              </div>
              
              <div class="price-section">
                <div class="price-label">Valor Total:</div>
                <div class="price-amount">
                      {{
                        products.filter((p) => p.code == codes[service])[0]
                          ? new Intl.NumberFormat("cl-CL", {
                              style: "currency",
                              currency: "CLP",
                            }).format(
                              amount *
                                products.filter((p) => p.code == codes[service])[0]
                                  .price
                            )
                          : "---"
                      }}
                </div>
                <div class="price-currency">CLP</div>
              </div>
              
              <div class="purchase-button">
                <span class="button-text">Proceder al Pago</span>
                <span class="button-arrow">→</span>
              </div>
                  </b-card>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import userService from "../../../services/userService";
import redpieService from "@/services/redpieService";
import transactionService from "@/services/transactionService";
import { trackPurchaseFromServer } from "@/services/analytics";
import {
  CHILE_CODE,
  COUNTRY_OPTIONS,
  resolveCountryCode,
} from "@/constants/countryCodes";

export default {
  computed: {
    countryOptions() {
      return COUNTRY_OPTIONS;
    },
    isExport() {
      // Only a factura to a non-Chilean country becomes an export. Boletas are
      // always domestic (the country selector is locked to Chile for them).
      return this.documentType === "factura" && Number(this.country) !== CHILE_CODE;
    },
    effectiveDocumentType() {
      // boleta -> boleta (33... 39), factura+Chile -> factura, factura+foreign -> exportacion
      return this.isExport ? "exportacion" : this.documentType;
    },
    rutIsValid() {
      return this.validateRut(this.rut);
    },
    // Usos que le quedan hoy del servicio que está comprando. El store guarda
    // cada contador con su propio nombre, así que el mapa vive acá y no en una
    // cadena de ternarios dentro del template (donde agregar un servicio
    // significaba anidar uno más y era justo lo que faltaba para Tests).
    currentUses() {
      const uses = {
        eureka: this.$store.state.login.eurekaUses,
        planification: this.$store.state.login.planificationsUses,
        documents: this.$store.state.login.documentsUses,
        materials: this.$store.state.login.materialsUses,
        tests: this.$store.state.login.testsUses,
      }[this.service];
      return Number(uses) || 0;
    },
  },
  created() {},
  mounted() {
    if (!this.$store.state.login.token) {
      this.$toasted.error("Tu sesión ha expirado.");
      this.$store.commit("login/setUserEmpty");
      this.$router.push({ name: "login" });
    } else {
      this.loading = true;
      this.getBillData();
      this.getProducts();
      this.service = this.$route.params.service;
    }
  },
  data: function () {
    return {
      service: "eureka",
      servicesNames: {
        eureka: "Eureka",
        planification: "Planificaciones",
        documents: "Documentos PIE",
        materials: "Pruebas Informales",
        tests: "Corrección de Tests",
        utopie: "Utopie",
        utopie_plus: "UtopiePlus",
      },
      // Los códigos son los de BusinessProduct. 'TEST' ya existía en el
      // catálogo (y ServiceLog.USER_USES_FIELD ya lo mapea a tests_uses, que es
      // lo que acredita transaction_redirect); lo único que faltaba para poder
      // comprar usos de Corrección de Tests era esta entrada.
      codes: {
        eureka: "EUR_STU",
        planification: "PLANI",
        documents: "DOCUMENT",
        materials: "MATERIAL",
        tests: "TEST",
        utopie: "UTP_STU",
        utopie_plus: "UTP_PLUS",
      },
      name: this.$store.state.login.first_name,
      lastName: this.$store.state.login.last_name,
      country: CHILE_CODE,
      email: this.$store.state.login.email,
      phone: "",
      address: "",
      city: "",
      rut: "",
      rutTouched: false,
      razonSocial: "",
      giro: "",
      comuna: "",
      documentType: "boleta",
      documentTypeOptions: [
        { text: "Persona natural (Boleta)", value: "boleta" },
        { text: "Persona jurídica (Factura)", value: "factura" },
      ],
      loading: false,
      oneClickIcon: require("../../../assets/img/webpay/SVG_WebpayOneclick/_FondoBlanco_SVG/_800PX/1.WebpayOneclick_FB_800px.svg"),
      webpayIcon: require("../../../assets/img/webpay/SVG_Webpay/_FondoBlanco_SVG/_800PX/1.Webpay_FB_800.svg"),
      amount: 1,
      products: [],
      selectedLevel: null,
      // Los valores son los de GradeEnum en el backend. Va de 1° básico a 3°
      // medio porque es el tramo que Eureka cubre: el catálogo no tiene ni una
      // prueba para pre-kínder, kínder ni 4° medio. Ofrecer esos niveles sería
      // prometer un curso de ejemplo que nunca se va a poder aplicar.
      levelOptions: [
        { value: null, text: "Selecciona un nivel", disabled: true },
        { value: 2, text: "1° básico" },
        { value: 3, text: "2° básico" },
        { value: 4, text: "3° básico" },
        { value: 5, text: "4° básico" },
        { value: 6, text: "5° básico" },
        { value: 7, text: "6° básico" },
        { value: 8, text: "7° básico" },
        { value: 9, text: "8° básico" },
        { value: 10, text: "1° medio" },
        { value: 11, text: "2° medio" },
        { value: 12, text: "3° medio" },
      ],
      levelPromise: null,
    };
  },
  destroyed: function () {},
  methods: {
    formatRut(value) {
      if (!value) return "";
      const cleaned = String(value)
        .replace(/[^0-9kK-]/g, "")
        .toUpperCase()
        .replace(/-/g, "");
      if (cleaned.length <= 1) return cleaned;
      return cleaned.slice(0, -1) + "-" + cleaned.slice(-1);
    },
    validateRut(rut) {
      if (typeof rut !== "string" || !rut) return false;
      if (!/^0*(\d{1,3}(\.?\d{3})*)-?([\dkK])$/.test(rut)) return false;
      const clean = rut.replace(/^0+|[^0-9kK]+/g, "").toUpperCase();
      if (clean.length < 2) return false;
      let t = parseInt(clean.slice(0, -1), 10);
      let m = 0;
      let s = 1;
      while (t > 0) {
        s = (s + (t % 10) * (9 - (m++ % 6))) % 11;
        t = Math.floor(t / 10);
      }
      const v = s > 0 ? "" + (s - 1) : "K";
      return v === clean.slice(-1);
    },
    getProducts() {
      transactionService.getProducts().then((data) => {
        this.products = data;
      });
    },
    // login.school sale de localStorage, así que además de ausente puede venir
    // como los strings "null"/"undefined" (los deja el logout). Sin esto el
    // front manda "null" al backend y la compra se acredita en la nada.
    currentSchoolId() {
      const school = this.$store.state.login.school;
      if (!school || school === "null" || school === "undefined") return null;
      return school;
    },
    // Eureka anota los usos contra el colegio. Quien compra sin tener uno
    // —hoy la mayoría de los que llegan por "Comprar usos!"— necesita que
    // exista antes de ir a Webpay: al volver, el store se lee de localStorage
    // y no se entera de un colegio creado en el servidor.
    ensureSchoolForPurchase(code) {
      if (code !== "EUR_STU" || this.currentSchoolId()) {
        return Promise.resolve(this.currentSchoolId());
      }
      return this.askPurchaseLevel().then((level) =>
        redpieService
          .ensureSchool({ reason: "compra eureka", level: level })
          .then((data) => {
            this.$store.commit("login/setSchool", data.school);
            this.$store.commit("login/setEurekaUses", data.eureka_uses);
            return data.school;
          })
      );
    },
    askPurchaseLevel() {
      this.selectedLevel = null;
      return new Promise((resolve, reject) => {
        this.levelPromise = { resolve, reject };
        this.$refs["level-modal"].show();
      });
    },
    confirmLevel() {
      const pending = this.levelPromise;
      this.levelPromise = null;
      if (pending) pending.resolve(this.selectedLevel);
    },
    // Cerrar el modal sin elegir cancela la compra. Seguir de largo lo mandaría
    // a Webpay sin colegio, que es exactamente lo que perdía el cargo.
    onLevelModalHidden() {
      const pending = this.levelPromise;
      this.levelPromise = null;
      if (pending) pending.reject(new Error("nivel no elegido"));
    },
    handleCardClick(code) {
      this.saveBillData().then(result => {
        console.log(result)
        if (!result) return;
        this.ensureSchoolForPurchase(code).then((schoolId) => {
          transactionService
            .createTransaction({
              code: code,
              amount: this.amount,
              school_id: schoolId,
              document_type: this.effectiveDocumentType,
            })
            .then((data) => {
              if (data.token && data.url) {
                var token = data.token;
                var redirectUrl = data.url;

                var form = document.createElement("form");
                form.method = "post";
                form.action = redirectUrl;

                var tokenInput = document.createElement("input");
                tokenInput.type = "hidden";
                tokenInput.name = "token_ws";
                tokenInput.value = token;

                var submitButton = document.createElement("input");
                submitButton.type = "submit";
                submitButton.value = "Ir a pagar";

                form.appendChild(tokenInput);
                form.appendChild(submitButton);

                document.body.appendChild(form);
                form.submit();
              }
              // Compra con tarjeta inscrita: se autoriza en esta misma
              // llamada y nunca pasa por la pantalla de éxito, así que el
              // evento de compra se dispara acá.
              if (data.authorized) {
                trackPurchaseFromServer();
              }
              if (data.message) {
                this.$toasted.success(data.message);
              }
            });
        })
        .catch(() => {
          // El único rechazo posible acá es que haya cerrado el modal del
          // nivel: no hay nada que avisarle, simplemente no compra.
        });
      });
    },
    getBillData() {
      userService.getBillData().then((data) => {
        this.name = data.name ? data.name : this.$store.state.login.first_name;
        this.lastName = data.lastName
          ? data.lastName
          : this.$store.state.login.last_name;
        this.country = resolveCountryCode(data.country);
        this.email = data.email ? data.email : this.$store.state.login.email;
        this.phone = data.phone ? data.phone : "";
        this.address = data.address ? data.address : "";
        this.city = data.city ? data.city : "";
        this.rut = data.rut ? data.rut : "";
        this.razonSocial = data.razonSocial ? data.razonSocial : "";
        this.giro = data.giro ? data.giro : "";
        this.comuna = data.comuna ? data.comuna : "";
        this.loading = false;
      });
    },
    async saveBillData() {
      const commonFieldsMissing =
        !this.name ||
        !this.lastName ||
        !this.country ||
        !this.email ||
        !this.phone ||
        !this.address ||
        !this.city;
      const domesticFieldsMissing =
        !this.isExport && !this.rut;
      const facturaFieldsMissing =
        this.effectiveDocumentType === "factura" &&
        (!this.razonSocial || !this.giro || !this.comuna);
      if (commonFieldsMissing || domesticFieldsMissing || facturaFieldsMissing) {
        this.$toasted.error("Por favor completa todos los campos obligatorios");
        return false;
      }
      if (!this.isExport && !this.validateRut(this.rut)) {
        this.rutTouched = true;
        this.$toasted.error("El RUT ingresado no es válido");
        return false;
      }
      const billData = {
        name: this.name,
        lastName: this.lastName,
        country: this.country != null ? this.country : CHILE_CODE,
        email: this.email,
        phone: this.phone,
        address: this.address,
        city: this.city,
        rut: this.rut,
        razonSocial: this.razonSocial,
        giro: this.giro,
        comuna: this.comuna,
        documentType: this.effectiveDocumentType,
      };
      await userService.saveBillData(billData).then((data) => {
        this.$toasted.success(data.message);
      });
      return true;
    },
  },
  watch: {
    documentType(val) {
      // Boleta is domestic-only: lock the country back to Chile.
      if (val === "boleta") {
        this.country = CHILE_CODE;
      }
    },
    token() {
      if (this.token) {
        this.$connect();
      } else {
        this.$disconnect();
      }
    },
    rut(val) {
      if (val == null) return;
      const formatted = this.formatRut(val);
      if (formatted !== val) {
        this.rut = formatted;
      }
    },
  },
};
</script>

<style lang="scss">
// Import Google Fonts for better typography
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

.default-container {
  margin-right: 0px !important;
  margin-left: 0px !important;
  padding-top: 85px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="50" cy="10" r="0.5" fill="rgba(255,255,255,0.05)"/><circle cx="10" cy="60" r="0.5" fill="rgba(255,255,255,0.05)"/><circle cx="90" cy="40" r="0.5" fill="rgba(255,255,255,0.05)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    opacity: 0.3;
    pointer-events: none;
  }
}

// Responsive padding
.responsive-padding {
  padding-left: 17rem !important;
  padding-right: 17rem !important;
  
  @media (max-width: 1200px) {
    padding-left: 8rem !important;
    padding-right: 8rem !important;
  }
  
  @media (max-width: 992px) {
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }
  
  @media (max-width: 768px) {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  
  @media (max-width: 576px) {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
}

// Hero Section Styling
.hero-section {
  text-align: center;
  margin-bottom: 2rem;
  animation: fadeInUp 0.8s ease-out;
}

.hero-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 2.5rem;
  color: white;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  
  .title-icon {
    display: inline-block;
    margin-right: 0.5rem;
    animation: bounce 2s infinite;
  }
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
}

.title-underline {
  width: 100px;
  height: 4px;
  background: linear-gradient(90deg, #ff6b6b, #4ecdc4);
  margin: 0 auto;
  border-radius: 2px;
  animation: slideIn 1s ease-out 0.5s both;
}

// Usage Card Styling
.usage-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  padding: 1.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  animation: slideInLeft 0.8s ease-out 0.3s both;
  
  .usage-icon {
    font-size: 2rem;
    margin-right: 1rem;
    animation: pulse 2s infinite;
  }
  
  .usage-text {
    margin: 0;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    color: #333;
    
    .usage-count {
      color: #4ecdc4;
      font-weight: 700;
      font-size: 1.2em;
    }
  }
}

// Section Header Styling
.section-header {
  margin-bottom: 1.5rem;
  animation: fadeInUp 0.8s ease-out 0.6s both;
}

.section-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  color: white;
  margin: 0;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  
  .section-icon {
    margin-right: 0.5rem;
    animation: wiggle 2s infinite;
  }
}

// Form Container Styling
.form-container {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: slideInUp 0.8s ease-out 0.9s both;
}

.form-label {
  font-weight: 600 !important;
  color: #333 !important;
  font-family: 'Poppins', sans-serif !important;
  margin-bottom: 0.5rem !important;
}

// Document Type Radio Section
.document-type-section {
  background: rgba(102, 126, 234, 0.08);
  border: 2px solid rgba(102, 126, 234, 0.2);
  border-radius: 12px;
  padding: 1.25rem;
  transition: all 0.3s ease;

  .form-label {
    font-weight: 600 !important;
    color: #333 !important;
    font-family: 'Poppins', sans-serif !important;
    display: block;
  }
}

.document-type-radios {
  .custom-control {
    padding: 0.6rem 1rem;
    margin-bottom: 0.25rem;
    border-radius: 8px;
    transition: background 0.2s ease;

    &:hover {
      background: rgba(102, 126, 234, 0.08);
    }
  }

  .custom-control-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    color: #444;
    cursor: pointer;
  }

  .custom-control-input:checked ~ .custom-control-label {
    color: #667eea;
    font-weight: 600;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: #667eea;
    background-color: #667eea;
  }
}

.export-notice {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: rgba(78, 205, 196, 0.1);
  border: 1px solid rgba(78, 205, 196, 0.3);
  border-radius: 8px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  color: #333;

  .export-icon {
    font-size: 1.2rem;
  }
}

.form-input {
  border: 2px solid #e1e5e9 !important;
  border-radius: 10px !important;
  padding: 0.75rem 1rem !important;
  font-family: 'Poppins', sans-serif !important;
  transition: all 0.3s ease !important;
  
  &:focus {
    border-color: #4ecdc4 !important;
    box-shadow: 0 0 0 0.2rem rgba(78, 205, 196, 0.25) !important;
    transform: translateY(-2px);
  }
  
  &::placeholder {
    color: #999;
    font-style: italic;
  }
}

// Purchase Section Styling
.purchase-section {
  animation: slideInRight 0.8s ease-out 1.2s both;
}

.quantity-section {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
}

.quantity-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  
  .quantity-icon {
    font-size: 1.5rem;
    margin-right: 0.5rem;
    animation: rotate 3s linear infinite;
  }
  
  .quantity-title {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    color: #333;
    margin: 0;
  }
}

.quantity-input-container {
  display: flex;
  justify-content: center;
}

.quantity-input {
  max-width: 200px;
  text-align: center;
  border: 2px solid #4ecdc4 !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  font-size: 1.1rem !important;
  color: #333 !important;
  
  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(78, 205, 196, 0.25) !important;
    transform: scale(1.05);
  }
}

// Purchase Card Styling
.purchase-card-container {
  perspective: 1000px;
}

.purchase-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none !important;
  border-radius: 20px !important;
  padding: 2rem !important;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }
  
  &:hover {
    transform: translateY(-10px) rotateX(5deg);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    
    &::before {
      left: 100%;
    }
    
    .purchase-button {
      transform: translateX(5px);
      background: rgba(255, 255, 255, 0.2);
    }
    
    .button-arrow {
      transform: translateX(5px);
    }
  }
}

.purchase-header {
  text-align: center;
  margin-bottom: 1.5rem;
  
  .purchase-icon {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
    display: block;
    animation: float 3s ease-in-out infinite;
  }
  
  .purchase-title {
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    color: white;
    margin: 0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }
}

.payment-method {
  text-align: center;
  margin-bottom: 1.5rem;
}

.payment-icon {
  max-width: 200px;
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
  
  @media (max-width: 768px) {
    max-width: 150px;
  }
  
  @media (max-width: 576px) {
    max-width: 120px;
  }
}

.price-section {
  text-align: center;
  margin-bottom: 1.5rem;
  
  .price-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 0.5rem;
  }
  
  .price-amount {
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: 2rem;
    color: white;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }
  
  .price-currency {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
    font-size: 1.1rem;
  }
}

.purchase-button {
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  padding: 1rem 2rem;
  text-align: center;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  
  .button-text {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    color: white;
    font-size: 1.1rem;
  }
  
  .button-arrow {
    font-size: 1.2rem;
    transition: transform 0.3s ease;
  }
}

// Border right only on large screens
.border-right-lg {
  @media (min-width: 992px) {
    border-right: 2px solid rgba(255, 255, 255, 0.2);
  }
}

// Animations
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    width: 0;
  }
  to {
    width: 100px;
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes wiggle {
  0%, 7% {
    transform: rotateZ(0);
  }
  15% {
    transform: rotateZ(-15deg);
  }
  20% {
    transform: rotateZ(10deg);
  }
  25% {
    transform: rotateZ(-10deg);
  }
  30% {
    transform: rotateZ(6deg);
  }
  35% {
    transform: rotateZ(-4deg);
  }
  40%, 100% {
    transform: rotateZ(0);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

// Form spacing adjustments for mobile
@media (max-width: 768px) {
  .default-container {
    margin-right: 10px !important;
    margin-left: 10px !important;
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .hero-title {
    font-size: 1.8rem;
  }
  
  .usage-card {
    flex-direction: column;
    text-align: center;
    
    .usage-icon {
      margin-right: 0;
      margin-bottom: 0.5rem;
    }
  }
}

body {
  font-family: 'Poppins', sans-serif !important;
}
</style>
